import { Certification } from '../../certifications/models/certification';
import { ICertificationProviderQuery } from '../interfaces/certification-provider.query.interface';

export class CertificationProvider {
    id: string;
    providerName: string;
    type: number;
    status: number;
    certifications?: Certification[];
    isCertificationTargetMet?: boolean;
    createdAt: Date;
    updatedAt: Date;

    constructor(query?: ICertificationProviderQuery) {
        if (query) {
            this.id = query.id.toString();
            this.providerName = query.name;
            this.type = query.type;
            this.status = query.status;
            if (query.certifications?.length) {
                this.certifications = query.certifications.map((certification) => new Certification(certification));
            }
            this.isCertificationTargetMet = query.is_certification_target_met;
            this.createdAt = query.created_at ? new Date(query.created_at) : null;
            this.updatedAt = query.updated_at ? new Date(query.updated_at) : null;
        } else {
            this.id = null;
            this.providerName = null;
            this.type = null;
            this.status = null;
            this.certifications = null;
            this.isCertificationTargetMet = null;
            this.createdAt = null;
            this.updatedAt = null;
        }
    }
}
